// extracted by mini-css-extract-plugin
export default {"gridSection":"MuiKpiPaper_gridSection__Dypci","printGridBlock":"MuiKpiPaper_printGridBlock__J43lz","topSectionTitle":"MuiKpiPaper_topSectionTitle__i-vuG"};